import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { fetchAllNotifications, markNotificationAsRead, markAllNotificationsAsRead } from "../../store/slices/notificationSlice";
import { startNotificationConnection, getNotificationConnection } from "../../services/startNotificationConnection";
import user_img from "../../assets/images/user_img.png";
import { formatDate } from "../../utils/dateUtils";

const Notifications = () => {
  const dispatch = useAppDispatch();
  const { role, user } = useAppSelector((s) => s.user);
  const userId = user?.id;
  const NOTIFICATION_KEY = `notificationsPage_${userId}`;
  const notificationList = useAppSelector((s) => s.notification.listDataByKey[NOTIFICATION_KEY] || []);
  const notifications = notificationList;
  const unreadCount = useAppSelector((s) => s.user.totalByKey[NOTIFICATION_KEY] || 0);
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "";

  const loadNotifications = (id) => {
    if (!id) return;
    dispatch(fetchAllNotifications({
      params: { userId: id, role: role },
      key: NOTIFICATION_KEY
    }));
  };

  const handleMarkAsRead = (notificationId) => {
    dispatch(markNotificationAsRead({ notificationId, userId }));
  };

  const handleMarkAllAsRead = () => {
    dispatch(markAllNotificationsAsRead({ userId, roleName: role }));
  };

  useEffect(() => {
    const init = async () => {
      if (!userId) return;

      const connection = await startNotificationConnection(role);

      loadNotifications(userId);

      connection.on("ReceiveNotification", () => {
        loadNotifications(userId);
      });

      connection.on("NotificationUpdated", () => {
        loadNotifications(userId);
      });
    };

    init();

    return () => {
      const connection = getNotificationConnection();
      if (connection) {
        connection.off("ReceiveNotification");
        connection.off("NotificationUpdated");
      }
    };
  }, [userId, role]);

  return (
    <div className="notification_page mt_60">
      <div className="container">
        <div className="col-md-10 m-auto">
          <div className="white_box p-4">
            <div className="d-flex mb_16">
              <h4 className="fs_18 fw_400 mb-0">Notifications {unreadCount > 0 && <span className="fs_18 fw_700 mb-0">{unreadCount}</span>}</h4>
              {unreadCount > 0 && <button className="btn btn-sm btn_primary ms-auto" onClick={handleMarkAllAsRead}>Mark All as Read</button>}
            </div>
            {notifications.length > 0 ? (
              notifications.map((notification) => (
                <div key={notification.notificationId} className={`notifications_list py_12 border-bottom d-flex align-items-center ${!notification.isRead ? 'bg_blue' : ''}`}>
                  <div className="user_image">
                    <img src={notification.userProfile ? BASE_URL + notification.userProfile : user_img} alt="User" />
                  </div>
                  <div className="content mt_12 flex-grow-1">
                    <h6 className="fs_20 fw_400">{notification.title}</h6>
                    <p className="fs_16 fw_400">{notification.message}</p>
                    <p className="fs_16 fw_700 time">{formatDate(notification.createdAt)}</p>
                  </div>
                  {!notification.isRead && (
                    <button className="btn btn-sm btn_primary notification_btn" onClick={() => handleMarkAsRead(notification.notificationId)}>
                      Mark as Read
                    </button>
                  )}
                </div>
              ))
            ) : (
              <p className="text-center p-3">No notifications</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
